<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-首页">
    <div class="swipe">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="item in focusData" :key="item.photo"
          ><img :src="item.photo" alt
        /></van-swipe-item>
      </van-swipe>
      <!-- <el-carousel :interval="4000" arrow="always">
        <el-carousel-item v-for="item in focusData" :key="item.photo">
          <img :src="item.photo" alt />
        </el-carousel-item>
      </el-carousel> -->
    </div>
    <!-- <div class="sTitle">
        <h1>解码中医悬疑、揭示中医奥秘、诠释中医渊源、探索中医本质</h1>
      </div> -->
    <div class="program">
      <div class="showSomeProgram">
        <div class="pHeader">
          <MTtile title="项目展示"></MTtile>
        </div>
        <div class="pwrapper">
          <van-swipe class="my-swipe" :autoplay="0">
            <van-swipe-item
              v-for="(item, index) in Math.ceil(pnav.length / 4)"
              :key="index"
              ><ul>
                <!-- @click="$router.push(`/mProgramContent/${pitem.id}`)" -->
                <li
                  v-for="(pitem, pIndex) in pnav.slice(
                    index * 4,
                    (index + 1) * 4
                  )"
                  :key="pitem.name"
                  :style="(pIndex + 1) % 4 == 0 ? 'margin-right:0' : ''"
                >
                  <img ref="imghead" :src="pitem.picture" alt />
                  <p @click="ptoLink(pitem, pIndex)">{{ pitem.name }}</p>
                </li>
              </ul></van-swipe-item
            >
          </van-swipe>
          <!-- <el-carousel
            :autoplay="false"
            indicator-position="outside"
            arrow="never"
            ref="carousel"
          >
            <el-carousel-item
              v-for="(item, index) in Math.ceil(pnav.length / 4)"
              :key="index"
            >
            </el-carousel-item>
          </el-carousel> -->
        </div>
      </div>
    </div>
    <div class="news">
      <div class="newsWrapper">
        <div class="newsRight">
          <div class="newsRightNav">
            <div
              ref="line"
              :style="`left:${1.6 * currentIndex}rem`"
              class="line"
            ></div>
            <ul>
              <li ref="he" v-for="(item, index) in nav" :key="index">
                <h2 @click="toLink(item, index)">{{ item.title }}</h2>
              </li>
            </ul>
          </div>
          <div class="newsRightWrapper">
            <div
              class="newsRightContent"
              v-for="(item, index) in newsData"
              :key="index"
            >
              <h3 @click="$router.push(`/mNewsContent/${item.id}`)">
                {{ item.name }}
              </h3>
              <div class="newsRightContentTime">
                <p>时间: {{ item.putime }}</p>
                <p>浏览量: {{ item.countpublic }}</p>
              </div>
            </div>
            <h5 @click="$router.push('/mNews')">查看更多</h5>
          </div>
        </div>
      </div>
    </div>
    <div class="compution">
      <!-- <div class="compution"> -->
      <div class="cHeader">
        <MTtile title="合作机构"></MTtile>
      </div>
      <div class="allCom">
        <!-- :style="(index + 1) % 3 == 0 ? 'margin-right:0' : ''" -->
        <div class="comWrapper" v-for="(item, index) in comData" :key="index">
          <a
            :href="'http://' + item.link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img :src="item.path" :title="item.name" alt />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_URL } from "@/utils/base.js";
import { getFocus, getCom } from "@/api/home.js";
import { getNews } from "@/api/news.js";
import { videoPlayer } from "vue-video-player";
import { getProgram } from "@/api/product.js";
import objectFitImages from "object-fit-images";
import MTtile from "@/components/MTitle.vue";
import WOW from "wowjs";
export default {
  name: "Home",
  data() {
    return {
      nav: [
        {
          title: "行业动态",
        },
        {
          title: "机构动态",
        },
        {
          title: "项目动态",
        },
         {
          title: "活动展示",
          url: "/hdzs"
        }
      ],
      pnav: [{}],
      newsData: [],
      comData: [],
      currentIndex: 0,
      focusData: [],
      showNewsData: {},
      playerOptions: {
        //播放速度
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: false,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "16:9",
        // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            src: "",
          },
        ],
        //你的封面地址
        poster: "",
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          //全屏按钮
          fullscreenToggle: true,
        },
      },
    };
  },
  created() {
    this.getProgram();
    this.BASE_URL = BASE_URL;
  },
  mounted() {
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true,
      });
      wow.init();
    }, 200);
    this.getFocus();
    this.getCom();
    this.getAllNewsData();
    this.getNewsData();
    // this.slideBanner();
    objectFitImages(this.$refs.imghead);
  },
  //在页面离开时记录滚动位置
  beforeRouteLeave(to, from, next) {
    sessionStorage.setItem(
      "home_ps",
      document.documentElement.scrollTop || document.body.scrollTop
    );
    next();
  },
  //进入该页面时，用之前保存的滚动位置赋值
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      window.scrollTo({
        top: sessionStorage.getItem("home_ps"),
      });
      // window.scrollTo({
      //   top: sessionStorage.getItem("home_ps"),
      //   behavior: "smooth"
      // });
      // document.body.scrollTop = sessionStorage.getItem("home_ps");
      sessionStorage.clear("home_ps");
    });
  },
  methods: {
    // 轮播手滑切换
    // slideBanner() {
    //   //选中item的盒子
    //   let vm = this;
    //   var box = document.querySelector(".el-carousel__container");
    //   //手指起点X坐标
    //   var startPoint = 0;
    //   //手指滑动重点X坐标
    //   var stopPoint = 0;
    //   //重置坐标
    //   var resetPoint = function () {
    //     startPoint = 0;
    //     stopPoint = 0;
    //   };
    //   //手指按下
    //   box.addEventListener("touchstart", function (e) {
    //     //手指按下的时候停止自动轮播
    //     // vm.stopAuto();
    //     //手指点击位置的X坐标
    //     e = e || window.event;
    //     startPoint = e.changedTouches[0].pageX;
    //   });
    //   //手指滑动
    //   box.addEventListener("touchmove", function (e) {
    //     //手指滑动后终点位置X的坐标
    //     e = e || window.event;
    //     e.preventDefault();
    //     stopPoint = e.changedTouches[0].pageX;
    //   });
    //   //当手指抬起的时候，判断图片滚动离左右的距离
    //   box.addEventListener("touchend", function (e) {
    //     // console.log("1：" + startPoint);
    //     // console.log("2：" + stopPoint);

    //     if (stopPoint == 0 || startPoint - stopPoint == 0) {
    //       resetPoint();
    //       return;
    //     }
    //     if (startPoint - stopPoint > 0) {
    //       resetPoint();
    //       vm.$refs.carousel.next();
    //       return;
    //     }
    //     if (startPoint - stopPoint < 0) {
    //       resetPoint();
    //       vm.$refs.carousel.prev();
    //       return;
    //     }
    //   });
    // },
    // 获取轮播图
    async getFocus() {
      let focus = await getFocus();
      this.focusData = focus.filter((item) => {
        return (item.photo = BASE_URL + item.photo);
      });
    },
    // 获取项目
    async getProgram() {
      let program = await getProgram();
      this.pnav = program.filter((item) => {
        return (item.picture = BASE_URL + item.picture);
      });
    },
    // 获取合作机构
    async getCom() {
      let coms = new FormData();
      coms.append("page", 1);
      coms.append("rows", 1000);
      let com = await getCom(coms);
      this.comData = com.rows;
      this.comData.map((item) => {
        return (item.path = BASE_URL + item.path);
      });
    },
    // 获取新闻动态
    async getAllNewsData() {
      let news = new FormData();
      news.append("page", 1);
      news.append("rows", 50);
      news.append("xueyuan", "倒");
      let note = await getNews(news);
      note.rows.forEach((ele) => {
        if (ele.journalism) {
          this.showNewsData = ele;
          this.playerOptions.sources[0].src =
            BASE_URL + this.showNewsData.journalism;
          return false;
        }
      });
    },
    // 获取新闻动态
    async getNewsData() {
      let news = new FormData();
      news.append("page", 1);
      news.append("rows", 50);
      news.append("xueyuan", "倒");
      news.append("dentity", this.nav[this.currentIndex].title);
      let note = await getNews(news);
      this.newsData = note.rows;
      this.newsData = this.newsData.filter((item, index) => {
        if (item.journalism) {
          item.journalism = BASE_URL + item.journalism;
        }
        return index < 5;
      });
    },
    // 新闻动态切换
    toLink(item, index) {
      this.currentIndex = index;
      this.getNewsData();
    },
    // 点击切换
    ptoLink(pitem, index) {
      this.$router.push(`/mProgramContent/${pitem.id}`);
    },
    pausePlay(player) {
      //关闭弹窗-停止播放
      this.player.pause();
    },
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  components: { videoPlayer, MTtile },
};
</script>
<style lang="less" scoped>
.main {
  margin-top: 150px;
  width: 100%;
  .swipe {
    margin: 0 30px;
    position: relative;
    // /deep/.el-carousel__container .el-carousel__arrow--left {
    //   z-index: 102;
    // }
    // /deep/.el-carousel__container .el-carousel__arrow--right {
    //   z-index: 102;
    // }
    /deep/ .van-swipe-item {
      height: 300px;
      width: 690px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 10px;
      }
    }
    /deep/ .van-swipe__indicators {
      bottom: 30px;
    }
    // /deep/ .el-carousel__indicator--horizontal{
    //   padding: 5px 15px;
    // }
    /deep/ .van-swipe__indicator {
      width: 30px;
      height: 10px;
      background-color: #000;
      border-radius: 0;
    }
    /deep/ .van-swipe__indicator--active {
      background-color: #ff7233;
    }
    // /deep/ .el-carousel__indicator{
    //   background-color: #000;
    // }
    .sTitle {
      height: 100%;
      z-index: 10;
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.2);
      text-align: center;
      color: #ffffff;
      h1 {
        margin-top: calc(35vh);
        font-size: 30px;
        font-weight: 600;
        margin-bottom: 50px;
      }
      p {
        font-size: 16px;
      }
    }
  }
  .program {
    padding: 0 30px;
    .showSomeProgram {
      .pHeader {
        margin: 46px 0 26px;
      }
      .pwrapper {
        /deep/ .my-swipe {
          width: 690px;
          padding-bottom: 80px;
          ul {
            display: flex;
            li {
              width: 160px;
              margin-right: 16px;
              margin-left: 1px;
              img {
                width: 100%;
                height: 190px;
                margin-bottom: 16px;
                object-fit: cover;
                font-family: "object-fit: cover;";
              }
              p {
                line-height: 1.3;
                cursor: pointer;
                font-size: 16px;
                color: #3b3b3b;
                text-align: center;
              }
            }
          }
        }
        // /deep/.el-carousel__indicators--outside{
        //   bottom: 100px;
        // }
        // /deep/ .el-carousel__indicator--horizontal{
        //   padding: 5px 15px;
        // }
        /deep/ .van-swipe__indicators{
          bottom: 40px;
        }
        /deep/ .van-swipe__indicator {
          width: 30px;
          height: 10px;
          background-color: #000;
          border-radius: 0;
        }
        /deep/ .van-swipe__indicator--active {
          background-color: #0687c8;
        }
        // /deep/ .el-carousel__button {
        //   width: 30px;
        //   height: 10px;
        //   background-color: #000;
        // }
        // /deep/ .is-active {
        //   /deep/ .el-carousel__button {
        //     background-color: #0687c8;
        //   }
        // }
        // /deep/ .el-carousel__indicator{
        //   background-color: #000;
        // }
      }
    }
  }
  .news {
    width: 100%;
    padding-bottom: 20px;
    background-color: #f5f5f5;
    .newsWrapper {
      .newsRight {
        width: calc(100vw - 60px);
        margin: 0 30px;
        .newsRightNav {
          height: 80px;
          line-height: 80px;
          position: relative;
          .line {
            width: 130px;
            height: 3px;
            background-color: #ff7234;
            position: absolute;
            transition: 0.3s all linear;
            left: 0;
            bottom: -3px;
          }
          ul {
            display: flex;
            align-items: center;
            color: #212121;
            li {
              width: 130px;
              text-align: center;
              margin-right: 30px;
              font-size: 28px;
              h2 {
                cursor: pointer;
              }
            }
          }
        }
        .newsRightWrapper {
          width: 100%;
          .newsRightContent {
            width: 100%;
            color: #626262;
            padding-bottom: 30px;
            font-size: 28px;
            line-height: 1;

            h3 {
              cursor: pointer;
              margin-top: 30px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              &:hover {
                text-decoration: underline;
              }
            }
            .newsRightContentTime {
              margin-top: 20px;
              display: flex;
              justify-content: space-between;
              p {
                color: #626262;
              }
            }
          }
          h5 {
            width: 100%;
            height: 50px;
            font-size: 22px;
            color: #626262;
            cursor: pointer;
            margin-top: 20px;
            line-height: 50px;
            text-align: center;
            background-color: #fff;
            &:hover {
              color: #ff7233;
            }
          }
        }
      }
    }
  }
  .compution {
    width: calc(100vw - 60px);
    margin: 0 30px;
    .cHeader {
      margin: 46px 0 26px;
    }
    .allCom {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .comWrapper {
        width: 210px;
        height: 210px;
        background-color: #fff;
        border: #000 solid 1px;
        display: flex;
        margin-right: 10px;
        margin-bottom: 20px;
        justify-content: center;
        align-items: center;
        a {
          img {
            width: 150px;
            height: 150px;
            line-height: 210px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>